import React from "react";

import { useUserTeams } from "@wc/domain/goals";
import { ViewProvider } from "@wc/domain/nav/contexts/view-context";
import BaseLayout from "@wc/ui/components/layouts";

import { WCNavbar } from "../../nav";

/**
 * Layout specifically for feed page with view context for team selection
 * @param {object} props The component props
 * @param {React.ReactElement} props.children The nested page to pass through
 * @returns {React.ReactElement} Feed layout with view context
 */
export function FeedLayout({ children }) {
  const [selectedTeamId, setSelectedTeamId] = React.useState(null);
  const { teams, primaryTeamId, loading } = useUserTeams();

  // Set default team to primary team
  React.useEffect(() => {
    if (!selectedTeamId && primaryTeamId && !loading) {
      setSelectedTeamId(primaryTeamId);
    }
  }, [primaryTeamId, selectedTeamId, loading]);

  const viewContextValue = {
    view: "team",
    setView: () => {},
    teams,
    selectedTeamId,
    setSelectedTeamId,
  };

  return (
    <ViewProvider value={viewContextValue}>
      <BaseLayout>
        <WCNavbar text="WINCARDS" />
        <div className="mt-2">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </div>
      </BaseLayout>
    </ViewProvider>
  );
}
